const DELETED_ACCOUNT_STORAGE_KEY = 'pacarion.accountDeleted';
const DELETED_ACCOUNT_MESSAGE = 'Your account was deleted';

function readDeletedAccountNotice() {
  try {
    return sessionStorage.getItem(DELETED_ACCOUNT_STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function rememberDeletedAccount() {
  try {
    sessionStorage.setItem(DELETED_ACCOUNT_STORAGE_KEY, '1');
  } catch (error) {
    // Private browsing can block storage. The login screen still uses React state.
  }
}

function clearDeletedAccountNotice() {
  try {
    sessionStorage.removeItem(DELETED_ACCOUNT_STORAGE_KEY);
  } catch (error) {
    // Ignore storage failures.
  }
}

export {
  DELETED_ACCOUNT_MESSAGE,
  readDeletedAccountNotice,
  rememberDeletedAccount,
  clearDeletedAccountNotice,
};
